import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { TabBox, TabMenu } from '@app/components/Tab';

interface SettingTabMenuItemProps {
  activeUrls?: string[];
  title: string;
  to: string;
  visible: boolean;
}

function SettingTabMenuItem({ activeUrls, title, to, visible }: SettingTabMenuItemProps) {
  const history = useHistory();
  const { pathname } = useLocation();

  const isActive = useMemo((): boolean => {
    if (activeUrls) {
      return activeUrls.filter((url) => pathname.includes(url)).length > 0;
    }

    return pathname.includes(to);
  }, [activeUrls, pathname, to]);

  const handleMoveToTabMenu = useCallback(
    (pathName: string) => {
      history.push(pathName);
    },
    [history]
  );

  if (!visible) {
    return null;
  }

  return (
    <TabBox>
      <TabMenu
        isActive={isActive}
        onClick={() => {
          handleMoveToTabMenu(to);
        }}
      >
        {title}
      </TabMenu>
    </TabBox>
  );
}

export default SettingTabMenuItem;
